/* eslint-disable camelcase */
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import styled from 'styled-components';

import { Button } from './Button';
import { Input } from './Input';
import { GREY } from '../constants/colors';


const InputInnerWrapper = styled.div`
  width: 100%;
  padding: 20px;
  border: 1px solid ${GREY};
  border-radius: 3px;
  & input {
    margin-bottom: 10px;
  }
`;

export class UserEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: props.user.username || '',
      admin: props.user.admin || false,
      email: props.user.email || '',
      password: props.user.password || '',
      id: props.user.id || '',
    };
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleAdminChange = this.handleAdminChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      username: nextProps.user.username || '',
      admin: nextProps.user.admin || '',
      email: nextProps.user.email || '',
      password: nextProps.user.password || '',
      auth_token: nextProps.user.auth_token || '',
      id: nextProps.user.id || '',
    });
  }

  handleUsernameChange(e) {
    this.setState({username: e.target.value});
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  handleAdminChange(e) {
    this.setState({admin: e.target.checked});
  }

  handleSubmit() {
    const { username, email, password } = this.state;

    if (username && email && (this.props.new ? password !== '' : true)) {
      this.props.onSubmit(this.state);
    } else {
      Alert.error('All fields are required', {timeout: 2000});
    }
  }

  handleDelete() {
    this.props.onDelete(this.props.user.id);
  }

  render() {
    const {
      username, admin, email, password,
    } = this.state;

    return (
      <InputInnerWrapper>
        <Input
          onChange={this.handleUsernameChange}
          placeholder="Username"
          value={username}
        />
        <Input
          onChange={this.handlePasswordChange}
          placeholder="Password"
          type="password"
          value={password}
        />
        <Input
          onChange={this.handleEmailChange}
          placeholder="Email"
          type="email"
          value={email}
        />
        <input
          checked={admin}
          id="admin_change"
          onChange={this.handleAdminChange}
          type="checkbox"
        />
        <label htmlFor="admin_change">
          Admin
        </label>
        <Button
          block
          onClick={this.handleSubmit}
        >
          SAVE
        </Button>
        {this.state.id &&
          <Button
            block
            onClick={this.handleDelete}
            type="error"
          >
            DELETE USER
          </Button>
        }
      </InputInnerWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserEdit.js